import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { KNZUtilModule } from '@knz/util';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { ErrorCollectComponent } from './error-collect.component';

const COMPONENTS = [ErrorCollectComponent];

@NgModule({
  imports: [CommonModule, KNZUtilModule, NzIconModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class ErrorCollectModule {}
